module.exports = __webpack_public_path__ + "img/xmasParty1.5afc6b8c.jpg";